import { USER_URL } from "../constant/api";

export const fetchChargesApi = async () => {
    try {
        const response = await USER_URL.get(`/orders/seller/promotions/pending-payments/`);
        return response.data;
    } catch (error) {
        console.log("error in fetch charges", error);
        // throw error;
        
    }
}
